import ssq from '@/assets/lottery/101.png';
import fc3d from '@/assets/lottery/102.png';
import qlc from '@/assets/lottery/104.png';
import kl8 from '@/assets/lottery/105.png';
import dlt from '@/assets/lottery/201.png';
import pl3 from '@/assets/lottery/202.png';
import pl5 from '@/assets/lottery/203.png';
import qxc from '@/assets/lottery/204.png';
import sfc from '@/assets/lottery/401.png';
import rx9 from '@/assets/lottery/402.png';
import sfgg from '@/assets/lottery/404.png';
import bjdc from '@/assets/lottery/405.png';
import jclqLogo from '@/assets/lottery/406.png';
import jczqLogo from '@/assets/lottery/407.png';

export const LOTTERY_LOGO_MAP: { [key: string]: string } = {
  竞彩足球: jczqLogo,
  竞彩篮球: jclqLogo,
  胜负过关: sfgg,
  北京单场: bjdc,
  双色球: ssq,
  大乐透: dlt,
  排列三: pl3,
  排列五: pl5,
  七星彩: qxc,
  七乐彩: qlc,
  快乐八: kl8,
  福彩3D: fc3d,
  任选九: rx9,
  胜负彩: sfc,

  排列3: pl3,
  排列5: pl5,
  任选9场: rx9,
  胜负游戏: sfc,
  快乐8: kl8,
};
